import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { NationalIdentifier } from "./NationalIdentifier";
import { CustomerTaxResidencyModel } from "../../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { MifirCountryIdentifier } from "../../../../../../../Wrap/Models/Domains/Regulations/MifirCountryIdentifier";
import { MifirIdentifierType } from "../../../../../../../Wrap/Constants/Enums/Domain/MifirIdentifierType";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";

interface INationalIdentifierPairProps extends IProcessComponentProps {
    data: CustomerTaxResidencyModel;
    disabled?: boolean;
    mifirCountryIdentifier: MifirCountryIdentifier[];
    onChange: (
        mifirIdentifierIdentifier: MifirIdentifierType,
        customerTaxResidencyModel: CustomerTaxResidencyModel
    ) => void;
    isEdit?: boolean;
}

interface INationalIdentifierPairState {}

export class NationalIdentifierPair extends ProcessComponent<
    INationalIdentifierPairProps,
    INationalIdentifierPairState
> {
    constructor(props: INationalIdentifierPairProps) {
        super(props);
    }

    clientOwnThisIdentifier(data: CustomerTaxResidencyModel, mifirCountryIdentifier: MifirCountryIdentifier): boolean {
        switch (mifirCountryIdentifier.IdentifierType) {
            case MifirIdentifierType.PassportNumber:
                return !CommonHelper.isNullOrEmpty(data.PassportNumber);
            case MifirIdentifierType.NationalIdentifier:
                return !CommonHelper.isNullOrEmpty(data.NationalIdentifier);
            case MifirIdentifierType.TaxNumber:
                return !CommonHelper.isNullOrEmpty(data.TaxReference);
            default:
                return false;
        }
    }

    render() {
        const { data, mifirCountryIdentifier } = this.props;

        return (
            <NationalIdentifier
                onRef={(ref) => this.appendChild(ref)}
                data={data}
                onNationalIdentifierChange={(type, value) => this.onNationalIdenfierChange(type, value)}
                disabled={this.props.disabled}
                identifiers={mifirCountryIdentifier}
                onChange={() => {}}
                isEdit={this.props.isEdit || false}
            />
        );
    }

    onNationalIdenfierChange(mifirIdentifierIdentifier: MifirIdentifierType, value: string) {
        const { data } = this.props;
        switch (mifirIdentifierIdentifier) {
            case MifirIdentifierType.NationalIdentifier:
                data.NationalIdentifier = value;
                break;
            case MifirIdentifierType.PassportNumber:
                data.PassportNumber = value;
                break;
            case MifirIdentifierType.TaxNumber:
                data.TaxReference = value;
                break;
            default:
                break;
        }
        this.props.onChange(mifirIdentifierIdentifier, data);
    }
}
